import styled from "styled-components"

import { media, mixins } from "../styles"

const BodyText = styled.div`
  overflow-wrap: break-word;

  h2 {
    ${mixins.title3}
    margin-bottom: 55px;

    @media ${media.lg} {
      margin-bottom: 65px;
    }
  }

  h3 {
    ${mixins.title4}
    margin-bottom: 15px;

    @media ${media.lg} {
      margin-bottom: 20px;
    }
  }

  h4 {
    ${mixins.title6}
    font-weight: 400 !important;
    margin-bottom: 15px;

    @media ${media.lg} {
      margin-bottom: 20px;
    }
  }

  p,
  ul,
  ol,
  table,
  video,
  .gatsby-resp-iframe-wrapper {
    margin-bottom: 40px;

    + h2,
    + h3,
    + h4 {
      @media ${media.lg} {
        margin-top: 55px;
      }
    }
  }

  p,
  li {
    ${mixins.copy4}
  }

  li {
    margin-bottom: 10px;
  }

  hr {
    appearance: none;
    border: none;
    border-bottom: 1px solid ${({ theme }) => `rgba(${theme.sageRGB}, 0.5)`};
    height: 1px;
    line-height: 0;
    margin: 40px 0;
    padding: 0;

    @media ${media.lg} {
      margin: 60px 0;
    }

    @media ${media.xl} {
      margin: 80px 0;
    }
  }

  // Exclude table in code blocks (e.g. from Gists or Prism)
  table:not(.highlight) {
    border-collapse: collapse;
    ${mixins.copy5}
    text-align: left;

    thead {
      th {
        font-weight: 700;
        vertical-align: bottom;
      }
    }

    th,
    td {
      border-bottom: 1px solid ${({ theme }) => `rgba(${theme.sageRGB}, 0.5)`};
      padding: 20px 10px;
      vertical-align: top;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }
  }

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  img,
  video {
    max-width: 100%;
    height: auto;
  }

  video {
    display: block;
  }

  img + em,
  video + em,
  .gatsby-resp-image-wrapper + em {
    display: block;
    text-align: center;
    margin: 10px 0 16px;
    font-style: normal;
    opacity: 0.5;
    font-size: 14px;

    @media ${media.md} {
      font-size: 16px;
    }
  }

  .gatsby-resp-image-image {
    background-color: ${({ theme }) => theme.white};
  }

  .textpage-crossnav {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0.2px;
    margin: 0 0 40px;

    @media ${media.md} {
      margin: 0 0 60px;
    }
  }
`

export default BodyText
